const QUESTS_API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "/apivocabularium"
    : process.env.REACT_APP_QUESTS_API_URL ||
      "https://api.vocabularium.fr/apivocabularium";

export { QUESTS_API_BASE_URL };
export const QUESTS_API_URL = QUESTS_API_BASE_URL
  ? `${QUESTS_API_BASE_URL.replace(/\/$/, "")}/quests`
  : "";
